function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M321.093,244.759c-4.764-4.175-9.261-8.12-11.937-12.932c-0.089-0.164-0.184-0.325-0.282-0.484 c-8.386-13.416-11.139-42.7-12.961-62.08c-0.243-2.596-0.477-5.081-0.712-7.417c-0.015-0.153-0.034-0.305-0.055-0.458 c-3.61-25.277-12.541-61.671-34.577-91.498c-16.139-21.843-36.722-36.063-60.432-41.997v-1.708C200.138,11.747,188.39,0,173.952,0 c-14.439,0-26.186,11.747-26.186,26.186v1.708c-23.712,5.934-44.294,20.154-60.432,41.997 c-22.036,29.827-30.966,66.221-34.577,91.498c-0.023,0.152-0.041,0.304-0.056,0.458c-0.233,2.336-0.467,4.82-0.711,7.417 c-1.822,19.379-4.575,48.664-12.959,62.08c-0.099,0.159-0.194,0.32-0.286,0.484c-2.673,4.812-7.171,8.756-11.934,12.932 c-10.554,9.254-26.501,23.237-12.139,49.911c1.903,3.534,5.593,5.738,9.607,5.738h97.927c2.268,26.566,24.603,47.496,51.746,47.496 c27.144,0,49.476-20.93,51.745-47.496h97.926c4.015,0,7.703-2.204,9.607-5.738C347.593,267.996,331.645,254.013,321.093,244.759z  M173.953,320.379c-11.947,0-21.912-8.624-24.012-19.971h48.021C195.863,311.755,185.9,320.379,173.953,320.379z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 347.903 347.903",
    style: {
      enableBackground: "new 0 0 347.903 347.903"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell.105e98d7.svg";
export { ForwardRef as ReactComponent };